import React from 'react';
import c from 'classnames';
import { Field } from 'formik';
import Immutable from 'immutable';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import type { WebformEntity } from '../../../types/uncinc_profile/webform';
import WebformCustomCheckOut from '../Custom/CheckOut';
import WebformCustomMusicPlayerCheck from '../Custom/MusicPlayerCheck';
import WebformCustomFrequencyPlayer from '../Custom/FrequencyPlayer';
import {
  WEBFORM_KEY_CHECK_OUT_HIDDEN_FIELD,
  WEBFORM_KEY_FREQUENCY_PLAYER_HIDDEN_FIELD,
  WEBFORM_KEY_MUSIC_PLAYER_CHECK_HIDDEN_FIELD,
  WEBFORM_KEY_MUSIC_PLAYER_CHECK_HIDDEN_FIELD_2,
} from '../../../config/constants';

interface WebformHiddenProps extends Record<string, any> {
  entity: ImmutableEntity<WebformEntity>;
}

const WebformHiddenInner: React.FC<{ id: string }> = ({ id }) => {
  // For the music player check webform for Oorcheck we need to calculate a result
  // based on values from other fields. Since this calculation is custom, we use
  // this hidden field to do the calculation in the frontend.
  switch (id) {
    case WEBFORM_KEY_MUSIC_PLAYER_CHECK_HIDDEN_FIELD:
    case WEBFORM_KEY_MUSIC_PLAYER_CHECK_HIDDEN_FIELD_2: {
      return <WebformCustomMusicPlayerCheck />;
    }

    case WEBFORM_KEY_FREQUENCY_PLAYER_HIDDEN_FIELD: {
      return <WebformCustomFrequencyPlayer />;
    }

    case WEBFORM_KEY_CHECK_OUT_HIDDEN_FIELD: {
      return <WebformCustomCheckOut />;
    }

    default: {
      return null;
    }
  }
};

const WebformHidden: React.FC<WebformHiddenProps> = ({ entity, ...fieldProps }) => {
  const key = entity.get('#webform_key');
  const wrapperClassNames = c('WebformHidden', entity.getIn(['#wrapper_attributes', 'class'], Immutable.List()).join(' '));

  return (
    <div className={wrapperClassNames}>
      <WebformHiddenInner id={key} />

      <Field
        className="hidden"
        name={key}
        type="text"
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        value={fieldProps.values[key]}
      />
    </div>
  );
};

export default WebformHidden;
